/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : activeTaskRegistry.ts
// 설명 : 특정 탭(callPgmId)에서 백그라운드로 계속 진행 중인 작업(예: K2901B1의 스크래핑)이 있을 때,
//        탭을 닫기 전에 사용자에게 확인을 받기 위한 공용 레지스트리.
//        AgGrid.tsx의 hasUnsavedGrid()와 같은 역할이지만, "저장 안 한 그리드행" 대신
//        "서버에서 계속 실행 중인 백그라운드 작업"을 추적한다는 점이 다름.
/////////////////////////////////////////////////////////////////////////////////////////////////////////

interface ActiveTask {
  message?: string;        // 닫기 확인창에 보여줄 문구(없으면 useTabs쪽 기본 문구 사용)
  onForceClose?: () => void; // 사용자가 "닫기"를 확정했을 때 호출(예: 서버에 취소 요청 전송)
}

const activeTasks: Record<string, ActiveTask> = {};

export function registerActiveTask(callPgmId: string, task: ActiveTask | null): void {
  if (task) {
    activeTasks[callPgmId] = task;
  } else {
    delete activeTasks[callPgmId];
  }
}

export function getActiveTask(callPgmId: string): ActiveTask | undefined {
  return activeTasks[callPgmId];
}
